// frontend/src/components/common/NavigationLoader.tsx

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function NavigationLoader() {
  const location = useLocation();
  const progressRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const bar = progressRef.current;
    if (!bar) return;

    if (timerRef.current) clearTimeout(timerRef.current);

    bar.style.transition = 'none';
    bar.style.width = '0%';
    bar.style.opacity = '1';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        bar.style.transition = 'width 0.6s cubic-bezier(0.1, 0.05, 0.0, 1)';
        bar.style.width = '85%';
      });
    });

    timerRef.current = setTimeout(() => {
      bar.style.transition = 'width 0.2s ease';
      bar.style.width = '100%';

      timerRef.current = setTimeout(() => {
        bar.style.transition = 'opacity 0.3s ease';
        bar.style.opacity = '0';

        timerRef.current = setTimeout(() => {
          bar.style.width = '0%';
        }, 300);
      }, 200);
    }, 400);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location.pathname]);

  return (
    <>
      {/* Top Progress Bar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          zIndex: 99999,
          pointerEvents: 'none',
        }}
      >
        <div
          ref={progressRef}
          style={{
            height: '100%',
            width: '0%',
            opacity: 0,
            background: 'linear-gradient(90deg, #ec4899, #f97316)',
            boxShadow: '0 0 10px rgba(236, 72, 153, 0.7)',
            borderRadius: '0 2px 2px 0',
          }}
        />
      </div>

    </>
  );
}